import React, { Component } from "react";
import Icon from "../../2/Controls/Icon";
import TemplatePage from "./TemplatePage";
import TemplatePickerDialog from "./TemplatePickerDialog";
import withStoreTemplates from "./withStoreTemplates";
import { getModule, getTemplates, storeLocation } from "./templateUtils";

const GROUPS = [
  { module: "sales", title: "Sales" },
  { module: "inventory", title: "Inventory" }
];

// First screen: every document the store can print and whether it is set up
class PrintTemplateTypes extends Component {
  constructor(props) {
    super(props);
    this.state = { pickerType: null };
  }

  isSetUp = (type) => getTemplates(this.props, type.key).length > 0;

  goTo(type, path, state) {
    this.props.history.push(
      storeLocation(this.props.storeKey, `/${type.key}${path}`, state)
    );
  }

  onRowClick(type) {
    const templates = getTemplates(this.props, type.key);
    if (templates.length === 0) {
      this.goTo(type, "/gallery");
    } else if (templates.length === 1) {
      this.goTo(type, `/customize/${templates[0].key}`);
    } else {
      this.setState({ pickerType: type });
    }
  }

  renderType = (type) => {
    const [template] = getTemplates(this.props, type.key);
    return (
      <button
        key={type.key}
        type="button"
        className="pt-type-row"
        onClick={() => this.onRowClick(type)}
      >
        <span className="pt-type-icon"><Icon type={getModule(type)} /></span>
        <span className="pt-type-text">
          <span className="pt-type-name">{type.TransactionType}</span>
          <span className="pt-type-sub">
            {template ? template.PrintDisplayName : "Choose a template to get started"}
          </span>
        </span>
        <span className={"pt-status " + (template ? "is-done" : "is-pending")}>
          {template ? "Setup done" : "Pending"}
        </span>
        <Icon type="rightarrow" />
      </button>
    );
  };

  render() {
    const { props } = this;
    const { pickerType } = this.state;
    const types = (props.config.TransactionTypes || []).filter((t) => !t.IsDeleted);
    const doneCount = types.filter(this.isSetUp).length;

    return (
      <TemplatePage
        {...props}
        title="Print Templates"
        subtitle="Choose how each document looks when it prints"
      >
        <div className="pt-scroll">
          <div className="pt-overview">
            <div className="pt-store-bar">
              <label htmlFor="pt-store">Store</label>
              <select
                id="pt-store"
                className="form-control"
                value={props.storeKey}
                onChange={(e) => props.history.replace(storeLocation(e.target.value))}
              >
                {props.stores.map((store) => (
                  <option key={store.key} value={store.key}>
                    {store.StoreCode ? `${store.StoreCode} - ` : ""}
                    {store.StoreName}
                  </option>
                ))}
              </select>
            </div>
            <div className="pt-progress">
              <div className="pt-progress-text">
                <strong>{doneCount} of {types.length}</strong> documents set up
              </div>
              <div className="pt-progress-track">
                <span style={{ width: `${types.length ? (doneCount / types.length) * 100 : 0}%` }} />
              </div>
            </div>
          </div>
          <div className="pt-types">
            {GROUPS.map((group) => {
              // Pending documents after the ones already set up
              const rows = types
                .filter((t) => getModule(t) === group.module)
                .sort((a, b) => this.isSetUp(b) - this.isSetUp(a));
              return (
                rows.length > 0 && (
                  <div key={group.module} className="pt-type-group">
                    <div className="pt-section-title">{group.title}</div>
                    <div className="pt-type-list">{rows.map(this.renderType)}</div>
                  </div>
                )
              );
            })}
          </div>
        </div>

        {pickerType && (
          <TemplatePickerDialog
            templates={getTemplates(props, pickerType.key)}
            typeName={pickerType.TransactionType}
            onClose={() => this.setState({ pickerType: null })}
            onSelect={(t) => this.goTo(pickerType, `/customize/${t.key}`)}
          />
        )}
      </TemplatePage>
    );
  }
}

export default withStoreTemplates(PrintTemplateTypes);
